(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function applyInertness(container) {
    var hidden = container.getAttribute('aria-hidden') === 'true';
    var focusables = container.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < focusables.length; i++) {
      var el = focusables[i];
      if (hidden) {
        if (!el.hasAttribute('data-a11y-original-tabindex')) {
          el.setAttribute('data-a11y-original-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-original-tabindex')) {
        var original = el.getAttribute('data-a11y-original-tabindex');
        if (original === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', original);
        }
        el.removeAttribute('data-a11y-original-tabindex');
      }
    }
  }

  function sweep(root) {
    var hiddenEls = (root || document).querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < hiddenEls.length; i++) {
      applyInertness(hiddenEls[i]);
    }
  }

  function fixListStructure(root) {
    var ctx = root || document;
    // Strip non-<li> direct children out of <ul>s injected by flickity and other sliders
    // that wrap non-list content in a list container. axe's "list" rule checks tag names
    // strictly, so role="listitem" on the child isn't enough — we convert them to <li>.
    var uls = ctx.querySelectorAll('ul.flickity-enabled, ul[data-product-row]');
    for (var i = 0; i < uls.length; i++) {
      var ul = uls[i];
      var kids = Array.prototype.slice.call(ul.children);
      for (var j = 0; j < kids.length; j++) {
        var child = kids[j];
        if (child.tagName === 'LI' || child.tagName === 'SCRIPT' || child.tagName === 'TEMPLATE') continue;
        var li = document.createElement('li');
        for (var a = 0; a < child.attributes.length; a++) {
          var attr = child.attributes[a];
          li.setAttribute(attr.name, attr.value);
        }
        while (child.firstChild) li.appendChild(child.firstChild);
        ul.replaceChild(li, child);
      }
    }
    // Orphan <li> elements whose parent is not ul/ol/menu — swap them for <div role="listitem">.
    var orphanLis = ctx.querySelectorAll('li');
    for (var k = 0; k < orphanLis.length; k++) {
      var oli = orphanLis[k];
      var parent = oli.parentElement;
      if (!parent) continue;
      var tag = parent.tagName;
      if (tag === 'UL' || tag === 'OL' || tag === 'MENU') continue;
      var div = document.createElement('div');
      div.setAttribute('role', 'listitem');
      for (var b = 0; b < oli.attributes.length; b++) {
        var at = oli.attributes[b];
        div.setAttribute(at.name, at.value);
      }
      while (oli.firstChild) div.appendChild(oli.firstChild);
      parent.replaceChild(div, oli);
    }
  }

  function init() {
    sweep(document);
    fixListStructure(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden' && m.target instanceof Element) {
          applyInertness(m.target);
        } else if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node instanceof Element) {
              sweep(node);
              fixListStructure(node);
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true,
      childList: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
